import React from "react";
import "../assets/services.css";

const services = [
  {
    title: "Australia & USA Taxation",
    desc: "Comprehensive tax services ensuring compliance with international regulations and maximizing tax efficiency.",
    points: [
      "Individual & Business Tax Returns",
      "ATO & IRS Compliance",
      "Tax Planning & Advisory",
      "GST / BAS Filing"
    ]
  },
  {
    title: "Bookkeeping & Payroll",
    desc: "Accurate bookkeeping and payroll solutions designed to maintain financial clarity and compliance.",
    points: [
      "Daily Bookkeeping",
      "Payroll Processing",
      "Bank Reconciliation",
      "Financial Reporting"
    ]
  },
  {
    title: "E-Commerce Management",
    desc: "Full service management for online stores including product listings, inventory, and order fulfillment.",
    points: [
      "Amazon & Shopify Management",
      "Product Listing Optimization",
      "Inventory Management",
      "Order Processing"
    ]
  },
  {
    title: "Website Development",
    desc: "Custom business websites designed with modern UI, high performance, and scalability.",
    points: [
      "Corporate Websites",
      "Custom Web Applications",
      "SEO Optimization",
      "Performance Optimization"
    ]
  },
  {
    title: "Product Management",
    desc: "Strategic product development and lifecycle management to ensure market success.",
    points: [
      "Product Strategy",
      "Market Research",
      "Lifecycle Management",
      "Growth Optimization"
    ]
  },
  {
    title: "Business Consulting",
    desc: "Expert advisory services helping businesses scale operations and improve profitability.",
    points: [
      "Business Strategy",
      "Operational Improvement",
      "Financial Planning",
      "Startup Advisory"
    ]
  }
];

const Services = () => {
  return (
    <section className="services-section">

      <div className="services-header">
        <h1>Our Professional Services</h1>
        <p>
          We provide comprehensive financial, technology and consulting
          services that help businesses grow efficiently.
        </p>
      </div>

      {services.map((service, index) => (
        <div
          className={`service-row ${index % 2 === 0 ? "normal" : "reverse"}`}
          key={index}
        >
          <div className="service-image">
            <div className="image-placeholder">Service</div>
          </div>

          <div className="service-content">
            <h2>{service.title}</h2>
            <p>{service.desc}</p>

            <ul>
              {service.points.map((p, i) => (
                <li key={i}>{p}</li>
              ))}
            </ul>
          </div>
        </div>
      ))}

    </section>
  );
};

export default Services;